import { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import InternalItem from './InternalItem';
import AmazonItem from './AmazonItem';
import { useEffect } from 'react';
import Api from '../../utils/Api';
import ListContext from '../../hooks/ListContext';

const styles = css`
/* height: calc(100vh - 150px);
overflow-y: auto; */
padding-top: 20px;
display: flex;
flex-direction: column;
align-items: flex-start;
width: 100%;
gap: 20px;

> .controls {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.items {
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding:5px;
  padding-top: 0px;
  width: 100%;
}

@media print {
    > .controls {
        display: none;
      }
  }
`;

const WishList = styled(({ className }) => {
  const [sorted, setSorted] = useState([]);
  const [sortBy, setSortBy] = useState('priority');
  const {
    refetchList: refetch,
    list,
    context,
    canAddItem,
    onAddItem,
  } = useContext(ListContext);

  useEffect(() => {
    let sorted = [...list?.items ?? []];
    sorted.sort((a, b) => {
      let order = 1;
      let a1 = a[sortBy];
      let b1 = b[sortBy];
      if (['price'].includes(sortBy)) order = -1;
      if (sortBy === 'price') {
        a1 = parseFloat(a[sortBy].replace('$', ''));
        b1 = parseFloat(b[sortBy].replace('$', ''));
      }
      if (a1 < b1) return order;
      if (a1 > b1) return -order;
      else return 0;
    });
    setSorted(sorted);
  }, [sortBy, list?.items]);


  const toggleLike = async (item, emoji) => {
    await Api.toggleItemLike(list._id, item._id, { ...context, emoji });
    refetch();
  }

  const ItemRenderer = ({ item }) => {
    switch (item.source) {
      case 'internal':
        return <InternalItem item={item} toggleLike={toggleLike} />;
      case 'amazon':
        return <AmazonItem item={item} toggleLike={toggleLike} />;
      default:
        return null;
    }
  }

  const ListItems = ({ items }) => items.map((item, index) => <ItemRenderer key={index} item={item} toggleLike={toggleLike} />);

  return (
    <div className={className}>
      <div className='controls'>
        {
          canAddItem && <button className='primary' onClick={onAddItem}>
            <span>Add Item</span>
          </button>
        }
        <select value={sortBy} onChange={e => setSortBy(e.target.value)}>
          <option value='addedOn'>Added On (Most Recent)</option>
          <option value='price'>Price (Lowest)</option>
          <option value='stars'>Rating (Highest)</option>
          <option value='priority'>Priority (Highest)</option>
        </select>
      </div>
      <div className='items'>
        <ListItems items={sorted}/>
      </div>
    </div>
  )
})`${styles}`;

export default WishList;